import * as tPromise from "io-ts-promise";
import axios, { getData } from "../../../axios";
import { createSlice } from "@reduxjs/toolkit";
import { createErrorReportingAsyncThunk } from "../../helpers";
import { RootState } from "../../../redux-store";
import { CargoSplitInfo, cargoSplitsInfoT } from "dora-contracts";
import { handleCargoDeletedWhileLoading } from "../../app/cargo-dialog";

const prefix = "data/cargos-splits-info";

type State = {
  entities: Record<string, CargoSplitInfo[]>;
};

const initialState: State = {
  entities: {},
};

export const loadCargoSplitsForCargo = createErrorReportingAsyncThunk(
  `${prefix}/load`,
  async (
    cargoId: string,
    thunkAPI
  ): Promise<{ cargoId: string; splits: CargoSplitInfo[] }> => {
    try {
      const splits = await axios
        .get(`/api/cargos/${cargoId}/splits`)
        .then(getData)
        .then(tPromise.decode(cargoSplitsInfoT));
      return { cargoId, splits };
    } catch (e) {
      if (handleCargoDeletedWhileLoading(e, thunkAPI, cargoId)) {
        return { cargoId, splits: [] };
      }
      throw e;
    }
  }
);

const slice = createSlice({
  name: prefix,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(loadCargoSplitsForCargo.fulfilled, (state, action) => {
      state.entities[action.payload.cargoId] = action.payload.splits;
    });
  },
});

export default slice.reducer;

export const selectCargoSplitsForCargo =
  (cargoId: string) =>
  (state: RootState): CargoSplitInfo[] | undefined =>
    state.data.cargoSplitsInfo.entities[cargoId];
